import { z } from 'zod';

export const TablesSettingsSchema = z.object({
  _type: z.literal('TablesSettings'),
  defaultParty: z
    .object({
      adults: z.number(),
      children: z.number().nullable(),
    })
    .nullable(),
  adultOnlyBookings: z.boolean().nullable(),
  showChildAges: z.boolean(),
  cancellationsEnabled: z.boolean().optional().nullable(),
});
